class SUAdminClientCtrl {

    constructor(CONTENT_TYPE, $apiService, UserService, $uibModal, Notification, $rootScope, EVENTS) {

        this.clients = [];

        this.CONTENT_TYPE = CONTENT_TYPE;
        this.$apiService = $apiService;
        this.UserService = UserService;
        this.$uibModal = $uibModal;
        this.Notification = Notification;
        this.$rootScope = $rootScope;
        this.EVENTS = EVENTS;

        this.loadClients();
    }

    loadClients() {
        this.loading = true;
        this.$apiService.list(this.CONTENT_TYPE.CLIENT, '')
            .then(response => {
                this.clients = response.data;
                this.loading = false;
            });

    }

    addClient() {
        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'superuser/add-client.html',
            controller: 'AddUserCtrl',
            resolve: {
                rootFolder: () => '536ce1114e9c9835f6000001'
            }
        });
        modalInstance.result.then((newItem) => {
            this.createClient(newItem);
        }, () => {

        });
    }

    createClient(client) {
        this.$apiService.create(this.CONTENT_TYPE.CLIENT, client)
            .then(response => {
                this.$rootScope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Client  created.'});
                this.loadClients();
            }, error => {
                console.error(error);
            });
    }
    
    updateClient(client) {
        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'superuser/edit-client.html',
            controller: 'AddUserCtrl',
            resolve: {
                client: client
            }
        });
        modalInstance.result.then((newItem) => {
            this.updateClientRecord(newItem);
        }, () => {

        });
    }
    
    updateClientRecord(client) {
        this.$apiService.update(this.CONTENT_TYPE.CLIENT, client)
            .then(response => {
                this.$rootScope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Client  updated.'});
            }, error => {
                console.error(error);
            });
    }
    
    deleteClient(client) {
        var modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'delete-confirm.html',
            controller: 'DeleteConfirmationCtrl'
        });

        modalInstance.result.then(() => {
            this.$apiService.delete(this.CONTENT_TYPE.CLIENT, client.id)
                .then((response) => {
                    this.$rootScope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Client deleted.'});
                    this.loadClients();
                }, (response) => {
                    console.error(response);
                    console.error(response);
                });
        },() => {
            // NOOP
        });
    }

    flushEntityCache() {
        this.UserService.flushEntityCache().then( () => {
            this.$rootScope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': 'Entity cache flushed.'});
        });
    }
    

}

angular.module('cpm')
    .controller('SUAdminClientCtrl', ['CONTENT_TYPE', 'ApiService', 'UserService', '$uibModal', 'Notification', '$rootScope', 'EVENTS', SUAdminClientCtrl]);
